import { formatCurrency } from 'utils/global/currency.utils';
import './FooterAmount.scss';

interface IStatisticAmountProps {
  statistic?: number;
  className?: string;
}

export const FooterAmount = ({ statistic, className = '' }: IStatisticAmountProps) => {
  return (
    <div className={`flex ${className}`}>
      {formatCurrency(statistic)}
      <div className="footerAmountEmptyDiv" />
    </div>
  );
};

export default FooterAmount;
